'use strict';

var angular = require('angular');

require('angular-route');
require('angular-sanitize');
require('angular-animate');
require('velocity-animate');
require('angular-audio');
require('pikaday-angular');

require('./addtohomescreen');
require('./angular-ios9-uiwebview.patch');

var app = angular.module('olsalgApp', [
    'ngRoute',
    'ngSanitize',
    'ngAnimate',
    'ngAudio',
    'ngIOS9UIWebViewPatch',
    'pikaday'
]);

app.factory('RequestInterceptor', require('./services/request-interceptor'));

app.config(function($routeProvider, pikadayConfigProvider, $httpProvider) {
    var rand = '?' + Math.random().toString(36).substring(7);

    $routeProvider
        .when('/', {
            templateUrl: '/templates/front.html' + rand,
            controller: 'MainController'
        })
        .when('/prequiz', {
            templateUrl: '/templates/prequiz.html' + rand,
            controller: 'PreQuizController'
        })
        .when('/game', {
            templateUrl: '/templates/game.html' + rand,
            controller: 'GameController'
        })
        .when('/end', {
            templateUrl: '/templates/end.html' + rand,
            controller: 'EndGameController'
        })
        .when('/submit', {
            templateUrl: '/templates/submit.html' + rand,
            controller: 'EndGameController'
        })
        .when('/competition', {
            templateUrl: '/templates/competition.html',
            controller: 'EndGameController'
        })
        .when('/competitionAdmin', {
            templateUrl: '/templates/competition-admin.html',
            controller: 'CompetitionController'
        })
        .when('/done/:competition?', {
            templateUrl: '/templates/done.html' + rand,
            controller: 'EndGameController'
        })
        .when('/highscore', {
            templateUrl: '/templates/highscore.html',
            controller: 'HighscoreController'
        })
        .when('/stats', {
            templateUrl: '/templates/stats.html',
            controller: 'StatsController'
        })
        .when('/competitionAdmin', {
            templateUrl: '/templates/competition-admin.html',
            controller: 'CompetitionController'
        })
        .otherwise({
            redirectTo: '/'
        });


        pikadayConfigProvider.setConfig({
            firstDay: 1,
            i18n: {
                previousMonth : 'Forrige måned',
                nextMonth     : 'Neste måned',
                months        : ['Januar','Februar','Mars','April','Mai','Juni','Juli','August','September','Oktober','November','Desember'],
                weekdays      : ['Søndag','Mandag','Tirsdag','Onsdag','Torsdag','Fredag','Lørdag'],
                weekdaysShort : ['Søn','Man','Tir','Ons','Tor','Fre','Lør']
            }
        });

        $httpProvider.interceptors.push('RequestInterceptor');
});

app.run(function($rootScope) {
    $rootScope.competitionActive = false;
    $rootScope.competitionPartTwo = false;
    $rootScope.controller = '';
    window.parent.postMessage({ event: 'completed', 'passed': true }, '*');
    $rootScope.$on('$routeChangeSuccess', function(ev, data) {
        if (data.$$route && data.$$route.controller) {
            $rootScope.controller = data.$$route.controller;
        }

        scaleWindow();
    });
});

require('./controllers');

app.factory('ExcelExportService', require('./services/excel-export'));
app.factory('ParticipantService', require('./services/participant'));

function scaleWindow() {
    var vWidth = window.innerWidth,
        vHeight = window.innerHeight,
        defaultWidth = 1024,
        defaultHeight = 575,
        wRatio = vWidth / defaultWidth,
        hRatio = vHeight / defaultHeight,
        ratio = 1;

    if (wRatio < 1 || hRatio < 1) {
        ratio = Math.min(wRatio, hRatio);
        var fontSize = (ratio * 16) + 'px';

        document.documentElement.style.fontSize = fontSize;
    }

    var hSpace = 0;

    if (vHeight > defaultHeight && wRatio > 1) {
        var hSpace = (vHeight - defaultHeight) / 2;
    }
    else if (hRatio > wRatio) {
        var hSpace = (vHeight - (defaultHeight * wRatio)) / 2;
    }

    document.documentElement.style.paddingTop = hSpace + 'px';

    var gameWindow = document.getElementById('main-window');
    if ((gameWindow !== undefined && gameWindow !== null) && (gameWindow.style.marginTop !== '' || '0px' || undefined)) {
        gameWindow.style.marginTop = '0px';
    }
}

scaleWindow();

setTimeout(scaleWindow, 1000);

window.onresize = scaleWindow;

var addToHome = navigator.language.match(/en/) ? 'Add to Home Screen' : 'Legg til på Hjem-skjerm';

addToHomescreen({
    startDelay: 0,
    modal: true,
    skipFirstVisit: false,
    mandatory: false,
    maxDisplayCount: 0,
    displayPace: 1000,
    lifespan: 0,
    message: {
        ios: "For best mulig spillopplevelse anbefaler vi å legge denne siden på hjem-skjermen din.<br><br>Trykk på %icon og velg '" + addToHome + "', så vil siden dukke opp blant de andre appene dine.",
        android: "For best mulig spillopplevelse anbefaler vi å legge denne siden på hjem-skjermen din.<br><br>For å legge til denne webappen på startsiden åpner en nettlesermenyen og velger <strong>Legg til på startsiden</strong>. <small>Menyen åpnes ved å trykke på den fysiske menyknappen hvis enheten har det, eller ved å trykke på menyikonet øverst til høyre %icon.</small>"
    },
    onAdd: function() {
        alert('Lukk nettleseren, og åpne spillet fra hjem-skjermen din.');
    }
});
